import React from 'react';
import { ApplicationPage } from '../../components/applications/ApplicationPage';
import { employersPage } from '../../data/applicationPages';
export function EmployersPage() {
  return <ApplicationPage content={employersPage} data-id="element-1661" data-mp="1gt1e3uxqlkgt" />;
}